import { Role } from '../../utils/roles'

export enum AuthProvider {
  OKTA = 'OKTA',
  AUTH0 = 'AUTH0',
}

export enum UserProfileActionTypes {
  UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE',
  UPDATE_USER_PROFILE_ERROR = 'UPDATE_USER_PROFILE_ERROR',
  SET_OKTA_USER_ID = 'SET_OKTA_USER_ID',
  SET_DEFAULT_TIMEZONE = 'SET_DEFAULT_TIMEZONE',
}

export interface UserWalkthrough {
  flyout: {
    productListingWalkthrough: boolean
  }
  oppsync: Record<string, unknown>
}

export interface UserProfile {
  id?: string
  sub?: string
  givenName?: string
  familyName?: string
  firstName?: string
  lastName?: string
  mobilePhone?: string
  email?: string
  timeZone?: string
  oldPassword?: string
  newPassword?: string
  roles?: Role[]
  defaultTimeZone?: string
  idpUserId?: string
  walkthroughs?: UserWalkthrough
}

export type IdentityServiceUser = {
  firstname: string
  lastname: string
  email: string
  timezone?: string
  id: string
  roles: Role[]
  idp_user_id: string
  walkthroughs?: UserWalkthrough
}
